import { EventBus } from '@/plugins/event-bus'
import types from '~/utils/types'

export const editorsMixin = {
  methods: {
    async downloadEditorPhoto(event, photo, critic) {
      event.preventDefault()
      if (
        this.me && (this.me.isEditor || this.me.isAdmin || this.me.role === types.user.role.curator)
      ) {
        try {
          this.$store.commit('SET_LOADER_DIALOG', true)
          const r = photo.url.replace('_wm', '')
          const url = r.replace('tr:n-full', critic ? 'tr:n-full_z_wm_v6' : 'tr:n-full_l_wm_v6')
          const data = await fetch(url)
          const blob = await data.blob()
          const blobUrl = URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = blobUrl
          a.download = `100ASA Editors Photo - ${photo.title} - ${photo.photographerName}`
          const clickHandler = function() {
            setTimeout(() => {
              URL.revokeObjectURL(blobUrl)
              this.removeEventListener('click', clickHandler)
            }, 150)
          }
          a.addEventListener('click', clickHandler, false)
          a.click()
        } catch (error) {
          this.$asa.appInsights('Mixins: editorsMixin.js - method: downloadEditorPhoto', error)
        } finally {
          this.$store.commit('SET_LOADER_DIALOG', false)
        }
      } else {
        EventBus.$emit('snackbar', {
          text:
            "You don't have permission to download this photo.",
          color: 'info'
        })
      }
    },
  }
}
